/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsInsideHorizontally: {
  name: 'chevrons-inside-horizontally';
  data: string;
} = {
  name: 'chevrons-inside-horizontally',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.707 7.293a1 1 0 0 0-1.414 1.414L7.586 12l-3.293 3.293a1 1 0 1 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4Zm14 1.414a1 1 0 0 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L16.414 12l3.293-3.293Z" fill="currentColor"/></svg>`,
};
